import { Component, Input } from '@angular/core';
import { CharacteristicItem } from '../../../../models/characteristic-item';

@Component({
  selector: 'app-caracteristique',
  templateUrl: './caracteristique.component.html',
  styleUrls: ['./caracteristique.component.scss'],
})
export class CaracteristiqueComponent {
  @Input() characteristicItem!: CharacteristicItem;
}
